import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum ZapRowToggleZapInteractionOption {
  Enable = "enable",
  Disable = "disable",
}

export function useEmitZapRowToggleZapEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: ZapRowToggleZapInteractionOption) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.ZapRowToggle,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
